import React, { ReactElement } from 'react';
import SidePanel from 'adapter/in/dashboards/components/SidePanel';
import { useDashboardEdit } from 'adapter/in/dashboards/context/EditDashboard';
import useWidgetMenu from 'adapter/in/dashboards/containers/EditDashboard/WidgetMenu/useWidgetMenu';

const WidgetMenuContainer = (): ReactElement => {
    const { showSidePanelMenu } = useDashboardEdit();
    const { title, content, onClose, onBack } = useWidgetMenu();
    return <SidePanel title={title} content={content} onClosePanel={onClose} onGoBack={onBack} showPanel={showSidePanelMenu} />;
};

export default WidgetMenuContainer;
